import { Controller } from "@hotwired/stimulus"

// Keeps the server-rendered profile tab in sync with the tab selected in Bootstrap.
export default class extends Controller {
  connect() {
    this.handleShown = this.persistSelectedTab.bind(this)
    this.jqueryElement = window.jQuery ? window.jQuery(this.element) : null

    if (this.jqueryElement) {
      this.jqueryElement.on("shown.bs.tab.profileTabs", this.handleShown)
    } else {
      this.element.addEventListener("shown.bs.tab", this.handleShown)
    }
  }

  disconnect() {
    if (this.jqueryElement) {
      this.jqueryElement.off(".profileTabs")
    } else {
      this.element.removeEventListener("shown.bs.tab", this.handleShown)
    }
  }

  persistSelectedTab(event) {
    const tab = event.target.getAttribute("aria-controls")
    const profileTab = {
      profile: "profile",
      obraSocial: "obra_social",
      historiasClinicas: "historias",
      ordenesDeServicio: "ordenes_de_servicio",
      historialDeTurnos: "historial_de_turnos"
    }[tab]

    if (!profileTab) return

    const url = new URL(window.location.href)
    url.searchParams.set("profile_tab", profileTab)
    window.history.replaceState({}, "", url)
  }
}
